import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import Triple from './Triple';

import styles from './Triple.module.postcss';
import CDN_BASE from '../../../utils/cdn';

function HowItWorks({ title, className, text1, text2, text3, title1, title2, title3 }) {
  const { vehicle_type, city_name } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();
  const citySlug = city_name.toLowerCase();

  return (
    <section className={className || 'Section--extraPadding'}>
      <h3 className='u-phosphate u-mb2'>{title || 'How it works'}</h3>
      <div className={styles.Triple_wrapper}>
        <Triple
          image={`${CDN_BASE}/photos/${citySlug}-howitworks1.webp`}
          isResponsive
          title={title1 || '1. Tell us about the event'}
          text={text1 || 'Date, location, guest count, and what you know so far.'}
        />
        <Triple
          image={`${CDN_BASE}/photos/${citySlug}-howitworks2.webp`}
          isResponsive
          title={title2 || '2. Compare your options'}
          text={text2 || `Review available ${vehicleType}s, menus, pricing, and messages.`}
        />
        <Triple
          image={`${CDN_BASE}/photos/${citySlug}-howitworks3.webp`}
          isResponsive
          title={title3 || '3. Book the one that fits'}
          text={text3 || `Choose your ${vehicleType} and confirm the details.`}
        />
      </div>
    </section>
  );
}

export default HowItWorks;
